import FileDownload from '@/services/FileDownload'

export default function (params) {
    return FileDownload('/api/v1/companies/export', params)
}
